import React from "react";

export default function VitalsPage() {
  return (
    <div className="aqx-main-inner">
      <div className="aqx-main-header">
        <h1>Vitals</h1>
        <p>Vitals placeholder. This page will surface the operator's vital signs — Triage and Pulse — at a glance.</p>
      </div>
    </div>
  );
}
